import React from "react"
import Modal from 'react-modal'
import { Grid, Row, Col } from 'react-bootstrap'
import dayjs from 'dayjs'
import ReactTable from 'react-table'
import PackageIdCheck from '../DeliveryUtils/PackageIdCheck'

const customStyles = {
    content: {
        position: 'fixed',
        top: '20%',
        left: '12%',
        right: 'auto',
        bottom: 'auto',
        padding: 20,
        zIndex: 9999,
        border: 'none',
        width: '80%',
        height: '75%',
        backgroundColor: 'white',
        border: '1px solid lightgrey'
    }
}

const BrowseReport = (props) => {
    const { report, modalIsOpen, closeModal, keyedCarriers } = props

    console.log(report)

    // var packageIdCheck = (packageId) => {
    //     fetch(`${window.MYQLOCX_API}/subject/admin/bi/deliverystatus/${packageId}`, {
    //         method: 'get',
    //         headers: axios.defaults.headers.common
    //     }).then(t => t.json()).then(t => {
    //         var msg
    //         if (t._id) msg = "- Leveransern är registererad i Qlocx system"
    //         if (t.checkout && !!t.checkout.date) msg += "\n- Leveransen har blivit avlevererad"

    //         if (msg) return alert(msg)

    //         alert("Leveransen fick ej match")
    //     })
    // }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={modalIsOpen}
            onRequestClose={closeModal}
            style={customStyles}>

            <Grid fluid>
                <Row>
                    <Col xs={6} sm={6} md={6} lg={6} style={{ textAlign: 'left' }}>
                        {report.reportFriendlyName}
                    </Col>
                    <Col xs={6} sm={6} md={6} lg={6} style={{ textAlign: 'right' }}>
                        <span onClick={() => closeModal()} className="closeButton2">X</span>
                    </Col>
                </Row>

                <br />

                <Row>
                    <Col xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'left' }}>
                        Rapportern baserades på adresser: {report.queries}
                    </Col>

                </Row>

                <hr />

                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <ReactTable
                            data={report.data.reverse()}
                            filterable
                            columns={[
                                {
                                    Header: "Datum:",
                                    id: 'date',
                                    accessor: d => dayjs(d.date).format('HH:mm - DD/MM/YY')
                                },
                                {
                                    Header: "Paketid:",
                                    id: 'packageId',
                                    Cell: props => {
                                        const packageId = props.original.packageId
                                        return (
                                            <div>
                                                {packageId}<br />
                                                <PackageIdCheck packageId={packageId} />
                                            </div>
                                        )
                                    }
                                },
                                {
                                    Header: "Avsändare:",
                                    id: 'senderName',
                                    accessor: d => d.senderName
                                },
                                {
                                    Header: "Mottagarnamn:",
                                    id: 'receiverName',
                                    accessor: d => d.receiverName
                                },
                                {
                                    Header: "MottagarData:",
                                    id: 'queryIndicators',
                                    accessor: d => JSON.stringify(d.queryIndicators)
                                },
                                {
                                    Header: "UpphämtarData:",
                                    id: 'pickupIndicators',
                                    accessor: d => JSON.stringify(d.pickupIndicators)
                                },
                                {
                                    Header: "Transportör:",
                                    id: 'carrierId',
                                    accessor: d => keyedCarriers[d.carrierId] ? keyedCarriers[d.carrierId].organization : null
                                },
                                {
                                    Header: "",
                                    columns: [
                                        {
                                            expander: true,
                                            Header: () => <p>&nbsp;</p>,
                                            width: 65,
                                            Expander: ({ isExpanded, ...rest }) =>
                                                <div>
                                                    {isExpanded
                                                        ? <span>&#x2299;</span>
                                                        : <span>&#x2295;</span>}
                                                </div>,
                                            style: {
                                                cursor: "pointer",
                                                fontSize: 25,
                                                padding: "0",
                                                textAlign: "center",
                                                userSelect: "none"
                                            },
                                            Footer: () => <span>&hearts;</span>
                                        }
                                    ]
                                }
                            ]}
                            NoDataComponent={props => (null)}
                            showPagination={true}
                            showPageSizeOptions={false}
                            loading={!report.data.length}
                            loadingText="Laddar..."
                            pageSize={report.data.length}
                            className="-striped -highlight"
                            SubComponent={(o) => { const document = o.original; return <div style={{ padding: 10 }}>{JSON.stringify(document.queryIndicators)}</div> }}
                            defaultFilterMethod={(filter, row) => {
                                const id = filter.pivotId || filter.id
                                return row[id] !== undefined ? String(row[id].toLowerCase()).indexOf(filter.value.toLowerCase()) > -1 : true
                            }}
                        />
                    </Col>
                </Row>
            </Grid>
        </Modal>
    )
}

export default BrowseReport